'use client';

import { cn } from '@core/utils';

import { AD_UNIT_IDS } from '@/constants/ad';
import { isBannerAdHidden, useAd } from '@/hooks/useAd';

import { AdBadge } from './AdBadge';

interface DesktopSideAdBannerProps {
  className?: string;
  footer?: React.ReactNode;
}

export const DesktopSideAdBanner = ({
  className,
  footer,
}: DesktopSideAdBannerProps) => {
  const { containerRef, adState } = useAd(AD_UNIT_IDS.DESKTOP_SIDE_BANNER, {
    type: 'banner',
  });

  const hidden = isBannerAdHidden(adState);

  return (
    <aside
      className={cn('hidden w-250 shrink-0 flex-col gap-16 xl:flex', className)}
    >
      {!hidden && (
        //* 광고 SDK 가 native ad 를 mount 하며 inline style 의 height 를 무시하고
        //* div 높이를 늘리는 케이스가 있어, 부모에 size 를 강제하고 자식은 absolute 로 clip.
        <div className="relative size-250 shrink-0 overflow-hidden rounded-large bg-Gray-100">
          <AdBadge className="right-12 top-12" />
          <div
            ref={containerRef}
            className={cn(
              //* SDK 가 element.style.height/width 를 강제 set 하는 경우에도
              //* max-* 가 cap 해서 250 초과 방지 (광고 콘텐츠는 잘릴 수 있지만 layout 은 안전).
              'absolute inset-0 max-h-250 max-w-250',
              adState === 'idle' && 'hidden',
              adState === 'loading' && 'animate-pulse',
            )}
          />
        </div>
      )}
      {footer}
    </aside>
  );
};
